import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedName from 'I18n/components/FormattedName';
import { AvatarViewer } from '../features/avatar';
import { H1 } from 'foundations-components/transitional/components/H1';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/transitional/components/View';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UserProfile = ({
  avatarHash,
  firstName,
  lastName,
  email
}) => {
  const isMarketingThemeEnabled = getMarketingThemePreference();
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(TFlex, {
    align: isTablet ? 'start' : 'center',
    alignSelf: "stretch",
    direction: isTablet ? 'column' : 'row',
    justify: isTablet ? 'center' : 'start',
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(AvatarViewer, {
        avatarHash: avatarHash,
        borderColor: "border-core-on-fill-default",
        borderStyle: isMarketingThemeEnabled ? undefined : 'solid',
        borderWidth: "200",
        email: email,
        size: "lg"
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(View, {
        color: isMarketingThemeEnabled ? 'text-core-default' : 'text-core-on-fill-default',
        marginBlockStart: isTablet ? '300' : undefined,
        marginInlineStart: isTablet ? undefined : '500',
        textAlign: isTablet ? 'left' : 'center',
        children: /*#__PURE__*/_jsx(H1, {
          "data-test-id": "user-full-name",
          margin: "0",
          children: /*#__PURE__*/_jsx(FormattedName, {
            familyName: lastName,
            givenName: firstName
          })
        })
      })
    })]
  });
};
export default UserProfile;